import { render, staticRenderFns } from "./bulk-recover-modal.vue?vue&type=template&id=0ba628c4&scoped=true&"
import script from "./bulk-recover-modal.vue?vue&type=script&lang=ts&"
export * from "./bulk-recover-modal.vue?vue&type=script&lang=ts&"
import style0 from "./bulk-recover-modal.vue?vue&type=style&index=0&id=0ba628c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba628c4",
  null
  
)

export default component.exports